import $ from "jquery";
import Vue from "vue";
import * as ers from "../../../errorsmessages/errors";
import * as suc from "../../../successmessages/success";
import * as rt from "../../../routes/routes";
import * as ses from "../../../configurations/session/sessioncomplete";
import baseurl from "../../../configurations/baseurl/baseurl";
import router from "../../../router/index";

export const actions = {
  newPayments() {
    let pettyaccountDetails = {
      pettyaccounts_name: $(".pettyaccounts_name").val()
    };
    $(".creatingPettyaccount").hide();
    $(".creatingPettyaccountLoader").show();
    baseurl.post(rt.newPaymentaccounts, pettyaccountDetails).then(res => {
      $(".creatingPettyaccount").show();
      $(".creatingPettyaccountLoader").hide();

      //checking for response codes from backend api

      if (res.data.code === 200) {
        //success code
        suc.pettyaccountCreateSuccess();
      } else if (res.data.code === 402) {
        //validation code
        ers.validateErrors();
      } else if (res.data.code === 403) {
        //pettyaccount exits
        ers.PaymentExists();
      } else if (res.data.code === 404) {
        //error on inserting data
        ers.errorCreatingPaymentAccount();
      } else if (res.data.code === 405) {
        //no permission to create
        ers.noPermissionToCreate();
        router.push("/dashboard");
      } else if (res.data.code === 506) {
        //session expired
        ses.sessionComplete();
      }
    });
  },
  loadPettyaccounts({ commit }) {
    baseurl.get(rt.loadPettyaccounts).then(res => {
      $(".pettyaccountsLoader").hide();

      //checking for response codes from backend api

      if (res.data.code === 200) {
        //success codes
        commit("STORE_PETTYACCOUNTS", res.data.pettyaccounts);
      } else if (res.data.code === 404) {
        //error on loading data
        ers.errorLoadingPaymentAccount();
      } else if (res.data.code === 405) {
        //no permission to read
        ers.noPermissionToRead();
        commit("STORE_PETTYACCOUNTS", []);
        router.push("/dashboard");
      } else if (res.data.code === 506) {
        //session expired
        ses.sessionComplete();
      }
    });
  },
  viewCashAccount({ commit }, accounttypeId) {
    commit("STORE_PETTYACCOUNT_UPDATE", accounttypeId);
  }
};
export default actions;



// WEBPACK FOOTER //
// ./src/vuex/modules/pettyaccounts/actions.js